import React from 'react';
import { Box, Card, CardContent, Chip, Collapse, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { COVIDDataTable } from './COVIDDataTable';
import { SchemeConditions } from './SchemeConditions';

interface SchemeInstanceCardProps {
  instance: any;
  instanceKey: string;
  expanded: boolean;
  onToggle: (key: string) => void;
  formatMoney: (amount: number) => string;
}

export const SchemeInstanceCard: React.FC<SchemeInstanceCardProps> = ({
  instance,
  instanceKey,
  expanded,
  onToggle,
  formatMoney
}) => {
  return (
    <Card
      sx={{ mb: 2, cursor: 'pointer' }}
      onClick={() => onToggle(instanceKey)}
    >
      <CardContent sx={{ py: 2, position: 'relative' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
            <Box
              sx={{
                minWidth: 120,
                px: 2,
                py: 1,
                bgcolor: instance.in_case ? 'success.main' : 'grey.400',
                color: 'white',
                borderRadius: 1,
                textAlign: 'center'
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '0.875rem' }}>
                {instance.date}
              </Typography>
            </Box>
            <Box sx={{ minWidth: 140 }}>
              <Chip
                label={instance.in_case ? 'SCHEME' : instance.is_scheme ? 'SCHEME (NOT OWNER)' : 'NOT SCHEME'}
                color={instance.in_case ? 'success' : 'default'}
                size="small"
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="caption">
                Admits: {instance.snf_admits_cnt || 0} | Billed: {formatMoney(instance.total_billed)} |
                Paid: {formatMoney(instance.total_paid)}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ p: 0.5 }}>
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </Box>
        </Box>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box sx={{ pt: 2, borderTop: 1, borderColor: 'divider', position: 'relative' }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              {/* COVID Weekly Report Data - Left side, takes most width */}
              <COVIDDataTable
                covidData={instance.covid_data}
                snfAdmitsCnt={instance.snf_admits_cnt}
              />

              {/* Analysis Conditions Table - Right side, compact */}
              <SchemeConditions analysis={instance.analysis} />
            </Box>
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};